import { render, staticRenderFns } from "./ByCustomer.vue?vue&type=template&id=640a6f4c&scoped=true"
import script from "./ByCustomer.vue?vue&type=script&lang=js"
export * from "./ByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a6f4c",
  null
  
)

export default component.exports